import PINS from '../constants/districtMapPins.json';

// 地圖只顯示已核實嘅地區（由 scripts/build-district-map-pins.js 產生），
// 其他地區唔出圖釘，地區按鈕照用。cityKey 係 CITY_DISTRICTS 嘅英文城市名。
export function getDistrictPins(cityKey, districts) {
  const cityPins = PINS[cityKey];
  if (!cityPins) return [];
  const names = districts && districts.length ? districts : Object.keys(cityPins);
  return names
    .filter((name) => cityPins[name])
    .map((name) => ({ name, lat: cityPins[name][0], lng: cityPins[name][1] }));
}
